import axios from "axios";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { FaArrowLeft, FaEdit, FaPlus } from "react-icons/fa";
import {
  RadioGroup,
  FormControlLabel,
  Radio,
  TextField,
  Tooltip,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";


const SupplierView = () => {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const location = useLocation();
  const customerType = location.state?.customerType;

  const [tableRows, setTableRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const receiptsPerPage = 10;
  const limit = 50;
  const [isLoading, setIsLoading] = useState(true);

  const totalPages = Math.ceil(filteredRows.length / receiptsPerPage);
  const navigate = useNavigate();

  const paginate = (pageNumber) => {
    if (pageNumber >= 1) setCurrentPage(pageNumber);
  };

  const onEdit = (accountNoEditObject) => {
    const { accountNo, openDocumentTab, accountName } = accountNoEditObject;
    navigate("/supplierCreation", {
      state: {
        tabIndex: openDocumentTab ? 0 : 0,
        editAccNo: accountNo,
        custName: accountName,
      },
    });
  };

  // const onBack = () => navigate("/customerCreation");

  const fetchDocumentTableSupplier = async (page = 1, search) => {
    let apiPaths = JSON.parse(localStorage.getItem("apiPaths") || "[]");
    let companyCode = localStorage.getItem("companyCode") || "-";
    let department = localStorage.getItem("currentSelectedDepartment") || "-";
    let apiURL = "";
    apiURL = `${
      apiPaths[0]?.API_CONFIG
    }/api/CRMAccountListPage/${COMPANY_CODE}/ACCOUNTLIST/${department}/SUPPLIERS/-/${
      search || "-"
    }/${page}/${limit}`;

  

    try {
      const response = await axios.get(apiURL);
      setTableRows(response.data || []);
      setFilteredRows(response.data || []); // ✅ Set filtered rows initially
    } catch (err) {
      console.error("Error while fetchDocumentTable Supplier", err);
    } finally {
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchDocumentTableSupplier(currentPage , searchTerm);
  // }, [currentPage, customerType , searchTerm]);

  useEffect(() => {
    const delay = setTimeout(() => {
      fetchDocumentTableSupplier(currentPage, searchTerm);
    }, 100);

    return () => clearTimeout(delay);
  }, [searchTerm, customerType, currentPage]);

  // ✅ Filter table when searchTerm changes
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredRows(tableRows);
    } else {
      const filtered = tableRows.filter(
        (rec) =>
          rec.ACCOUNT?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          rec.DESCRIPTION?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredRows(filtered);
    }
  }, [searchTerm, tableRows]);

  const onSupplierCreation = () => {
    navigate(`/supplierCreation`);
    // window.location.reload(); // forces full refresh
  };

  return (
    <div className="mx-2">
      {/* Header */}
      <div className="flex flex-wrap items-center justify-between gap-16 mt-2">
        <div className="flex gap-12 justify-between items-center">
          <h2 className="text-lg text-gray-800">
            {/* {customerType === "Supplier" ? "Supplier View" : "Customer View"} */}
            Supplier View
          </h2>

          {/* <RadioGroup
            row
            name="customerType"
            value={customerType}
            disabled
            className="flex items-center"
          >
            <FormControlLabel
              value="Customer"
              control={<Radio size="small" color="default" />}
              label="Customer"
            />
            <FormControlLabel
              value="Supplier"
              control={<Radio size="small" color="default" />}
              label="Supplier"
            />
          </RadioGroup> */}
        </div>

        <div className="flex justify-end items-center">
          <input
            type="text"
            placeholder="Search by Account or Description"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-[300px] px-3 py-2 shadow-sm text-sm rounded-md bg-white border border-gray-300 placeholder-gray-400 focus:outline-none focus:border-gray-400"
          />
        </div>
        <div>
          {/* Back Button */}
          {/* <button
            onClick={onBack}
            className="hidden relative bg-gray-600 text-white font-medium text-[17px] px-2 py-[0.25em] pl-3 h-[1.8em] rounded-[0.9em] flex items-center overflow-hidden cursor-pointer group"
          >
            <span className="mr-10">Back</span>
            <div className="absolute right-[0.3em] bg-white h-[1.4em] w-[1.4em] rounded-[0.7em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.6em)] active:scale-95">
              <FaArrowLeft className="text-gray-600" />
            </div>
          </button> */}
          <button
            onClick={onSupplierCreation}
            className="relative ml-4 bg-green-600 text-white font-medium text-[17px] px-2 py-[0.35em]  h-[1.8em] rounded-[0.9em] flex items-center overflow-hidden cursor-pointer   group"
          >
            <span className="mr-8">New</span>
            <div className="absolute right-[0.3em] bg-white h-[1.2em] w-[1.4em] rounded-[0.7em] flex items-center justify-center transition-all duration-300 group-hover:w-[calc(100%-0.6em)]  active:scale-95">
              <FaPlus className=" text-green-600 " />
            </div>
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto mt-4 max-h-[60vh]">
        <table className="min-w-full bg-white border border-gray-200 text-sm shadow-sm">
          <thead className="bg-gray-100 sticky top-0 z-20 shadow-sm">
            <tr>
              {[
                "Account",
                "Description",
                "Patron Type",
                "Contact No",
                "Sales Person",
                "Balance",
                "Open Balance",
                "Credit Mode",
                "Credit Limit",
                "Due Days",
                "Created On",
                "TRN",
                "Action",
              ].map((header) => (
                <th
                  key={header}
                  className="px-4 py-1 font-semibold text-gray-700 border text-left"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredRows.length > 0 ? (
              filteredRows.map((rec, index) => (
                <tr
                  key={index}
                  className={`hover:bg-blue-50 border-b ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  }`}
                >
                  <td className="px-4 w-30 py-2 border text-xs text-left">
                    {rec.ACCOUNT}
                  </td>
                  <td className="px-4 py-2 w-54  border text-[0.78em] text-left">
                    {rec.DESCRIPTION || "-"}
                  </td>
                  <td className="px-4  w-36  py-2 border text-xs text-left">
                    {rec.Patron_Type || "-"}
                  </td>
                  <td className="px-4 py-2 border text-xs text-right">
                    {rec.Contact_No?.trim() || "-"}
                  </td>
                  <td className="px-4 py-2 w-36  border text-[0.78em] text-left">
                    {rec.Sales_Person || "-"}
                  </td>
                  <td className="px-4 py-2 border text-xs text-right">
                    {rec.BALANCE}
                  </td>
                  <td className="px-4 py-2 border text-xs text-right">
                    {rec.openbal}
                  </td>
                  <td className="px-4 py-2 w-36  border text-xs text-left">
                    {rec.Credit_Mode || "-"}
                  </td>
                  <td className="px-4 py-2 w-28  border text-xs text-right">
                    {rec.Credit_Limit}
                  </td>
                  <td className="px-4 py-2 w-28  border text-xs text-right">
                    {rec.Due_Days}
                  </td>
                  
                  <td className="px-4 py-2  w-28  border text-xs text-center">
                    {rec.Created_On
                      ? dayjs(rec.Created_On).format("DD/MM/YYYY")
                      : "-"}
                  </td>
                                    <td className="px-4 py-2 w-28  border text-xs text-right">
                    {rec.trn}
                  </td>
                  <td className="px-2 py-1 border-b text-xs text-gray-600 ">
                    <div className="flex justify-end gap-2">
                      <Tooltip title="Edit Supplier" arrow>
                        <button
                          onClick={() =>
                            onEdit({
                              accountNo: rec.ACCOUNT,
                              accountName: rec.DESCRIPTION,
                              openDocumentTab: true,
                            })
                          }
                          className="px-2 py-1 rounded text-white bg-blue-600 flex items-center gap-1 text-xs hover:bg-blue-700"
                        >
                          <FaEdit size={12} /> Edit
                        </button>
                      </Tooltip>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={11} className="text-center py-6 text-gray-500">
                  {isLoading ? "Loading Data..." : "No Matching Records Found"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex justify-between bg-gray-100 items-center px-2 py-4 shadow-sm rounded-md mt-2">
        <div className="text-sm text-gray-600">
          Showing page {currentPage} ({filteredRows.length} rows)
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className={`px-3 py-1 text-xs rounded-lg ${
              currentPage === 1
                ? "bg-gray-200 cursor-not-allowed"
                : "bg-blue-600 text-white hover:bg-blue-700"
            }`}
          >
            Previous
          </button>
          <span className="px-3 py-1 text-xs text-gray-700">
            {/* Page {currentPage} of {totalPages} */}
          </span>
   <button
      onClick={() => paginate(currentPage + 1)}
      disabled={currentPage === totalPages || filteredRows.length === 0}
      className={`px-3 py-1 text-xs rounded-lg ${
        currentPage === totalPages || filteredRows.length === 0
          ? "bg-gray-200 cursor-not-allowed text-gray-500"
          : "bg-blue-600 text-white hover:bg-blue-700"
      }`}
    >
      Next
    </button>
        </div>
      </div>
    </div>
  );
};

export default SupplierView;




// import React, { useState } from "react";
// import dayjs from "dayjs";
// const PDC = () => {
//   const dummyAccounts = [
//     {
//       INV: "INV-1001",
//       INVDATE: "2025-10-01",
//       BALAMT: 2500.75,
//       CUR: "USD",
//       RATE: 3.67,
//       FCBalAmt: 6826.78,
//       DEPTNO: "D001",
//     },
//     {
//       INV: "INV-1002",
//       INVDATE: "2025-09-15",
//       BALAMT: 1000.0,
//       CUR: "AED",
//       RATE: 1.0,
//       FCBalAmt: 1000.0,
//       DEPTNO: "D002",
//     },
//     {
//       INV: "INV-1003",
//       INVDATE: "2025-08-20",
//       BALAMT: 450.5,
//       CUR: "EUR",
//       RATE: 4.05,
//       FCBalAmt: 1822.52,
//       DEPTNO: "D003",
//     },
//     {
//       INV: "INV-1004",
//       INVDATE: "2025-10-10",
//       BALAMT: 760.0,
//       CUR: "USD",
//       RATE: 3.67,
//       FCBalAmt: 2789.2,
//       DEPTNO: "D004",
//     },
//     {
//       INV: "INV-1005",
//       INVDATE: "2025-07-05",
//       BALAMT: 1230.0,
//       CUR: "GBP",
//       RATE: 4.55,
//       FCBalAmt: 5606.5,
//       DEPTNO: "D005",
//     },
//   ];

//   const [accounts, setAccounts] = useState(dummyAccounts);
//   const [amounts, setAmounts] = useState([]);
//   const [sumOfAmounts, setSumOfAmounts] = useState(0);
//   const [selectedToggle, setSelectedToggle] = useState([]);
//   const onTransfer = () => {
//     // console.log("Accounts to transfer:", accountsToTransfer);
//     // onDataToSend(accountsToTransfer);
//   };

//   const handleSelectToggle = (index, checked) => {
//     setSelectedToggle((prev) => {
//       const updated = [...prev];
//       updated[index] = checked;
//       return updated;
//     });
//   };
//   return (
//     <div className="max-h-[800px] max-w-9xl mx-auto overflow-y-auto">
//       <div className="max-h-[700px] max-w-7xl mx-auto overflow-y-auto border rounded mb-4 bg-gray-100 font-normal">
//         <table className="relative w-full text-sm border-collapse">
//           <thead>
//             <tr>
//               <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
//                 Amount
//               </th>
//               <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1 z-10">
//                 Select
//               </th>
//               <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
//                 Bal Amount
//               </th>
//               <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
//                 Ref
//               </th>
//               <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
//                 Inv Date
//               </th>
//               <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
//                 Cur
//               </th>
//               <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
//                 Rate
//               </th>
//               <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
//                 FC Amount
//               </th>
//               <th className="bg-gray-100 font-normal sticky top-0 border px-2 py-1">
//                 Dept No
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {accounts?.length > 0 ? (
//               accounts.map((acc, index) => (
//                 <tr key={acc?.INV || index} className="text-sm font-thin">
//                   <td className="border w-24 bg-white">
//                     <input
//                       type="number"
//                       value={amounts[index] ?? ""}
//                       //   onChange={(e) =>
//                       //     handleAmountChange(index, e.target.value)
//                       //   }
//                       className="w-full border-none text-right rounded font-semibold text-sm"
//                     />
//                   </td>
//                   <td className="border w-24 bg-white  text-center">
//                     <label className="relative inline-block w-[3.5em] h-[2em]">
//                       <input
//                         type="checkbox"
//                         className="peer sr-only"
//                         checked={!!selectedToggle[index]}
//                         onChange={(e) =>
//                           handleSelectToggle(index, e.target.checked)
//                         }
//                       />
//                       <span
//                         className="
//                           absolute cursor-pointer inset-0 bg-gray-300 rounded-full transition-all duration-300 ease-in-out
//                           after:content-[''] after:absolute after:top-[4px] after:left-[4px] 
//                           after:w-[1.5em] after:h-[1.5em] after:bg-white after:rounded-full
//                           after:transition-all after:duration-300 after:ease-in-out
//                           after:shadow-[10px_0_40px_rgba(0,0,0,0.1)]
//                           peer-checked:bg-blue-500
//                           peer-checked:after:translate-x-[1.5em]
//                           peer-checked:after:shadow-[-10px_0_40px_rgba(0,0,0,0.1)]
//                           peer-active:after:w-[3em]
//                           peer-checked:peer-active:after:translate-x-[0.5em]
//                         "
//                       ></span>
//                     </label>
//                   </td>
//                   <td className="border bg-white px-2 py-1 text-right">
//                     {acc?.BALAMT ?? "-"}
//                   </td>
//                   <td className="border bg-white px-2 py-1 text-center">
//                     {acc?.INV ?? "-"}
//                   </td>
//                   <td className="border bg-white px-2 py-1 text-center">
//                     {acc?.INVDATE
//                       ? dayjs(acc.INVDATE).format("DD/MM/YYYY")
//                       : "-"}
//                   </td>
//                   <td className="border bg-white px-2 py-1 text-right">
//                     {acc?.CUR ?? "-"}
//                   </td>
//                   <td className="border bg-white px-2 py-1 text-right">
//                     {acc?.RATE ?? "-"}
//                   </td>
//                   <td className="border bg-white px-2 py-1 text-center">
//                     {acc?.FCBalAmt ?? "-"}
//                   </td>
//                   <td className="border bg-white px-2 py-1 text-center">
//                     {acc?.DEPTNO ?? "-"}
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan={9} className="text-center py-4 text-gray-500">
//                   No outstanding data available
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>
//       <div className="flex justify-between items-center">
//         <div>
//           <p>
//             Total:{" "}
//             <span className="font-semibold text-blue-700">{sumOfAmounts}</span>
//           </p>
//         </div>
//         <button
//           onClick={onTransfer}
//           type="button"
//           className="bg-blue-500 text-center w-32 rounded-xl h-10 relative text-white text-base font-medium group"
//         >
//           <div className="bg-white rounded-lg h-8 w-1/4 flex items-center justify-center absolute left-1 top-[4.5px] group-hover:w-[132px] z-10 duration-500">
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               viewBox="0 0 487.2 487.2"
//               className="h-4 w-4"
//               fill="#4299e1"
//             >
//               <g>
//                 <path d="M46.694,222.8h142.1c22.2,0,40.3-18.1,40.3-40.3V40.3c0-22.2-18.1-40.3-40.3-40.3h-142.1c-22.2,0-40.3,18.1-40.3,40.3v142.1C6.294,204.7,24.394,222.8,46.694,222.8z" />
//                 <path d="M477.294,102.7l-79.1-79.1c-4.8-4.8-12.5-4.8-17.3,0s-4.8,12.5,0,17.3l58.2,58.2h-170.8c-6.8,0-12.3,5.5-12.3,12.3s5.5,12.3,12.3,12.3h170.8l-58.2,58.2c-4.8,4.8-4.8,12.5,0,17.3c2.4,2.4,5.5,3.6,8.7,3.6s6.3-1.2,8.7-3.6l79.1-79.1C482.094,115.2,482.094,107.5,477.294,102.7z" />
//                 <path d="M480.894,446.9V304.8c0-22.2-18.1-40.3-40.3-40.3h-142.2c-22.2,0-40.3,18.1-40.3,40.3v142.1c0,22.2,18.1,40.3,40.3,40.3h142.1C462.794,487.2,480.894,469.1,480.894,446.9z" />
//                 <path d="M97.594,467.2c3.1,0,6.3-1.2,8.7-3.6c4.8-4.8,4.8-12.5,0-17.3l-58.2-58.2h170.8c6.8,0,12.3-5.5,12.3-12.3s-5.5-12.3-12.3-12.3h-170.8l58.2-58.2c4.8-4.8,4.8-12.5,0-17.3s-12.5-4.8-17.3,0l-79.1,79.1c-4.8,4.8-4.8,12.5,0,17.3l79.1,79.1C91.394,466,94.494,467.2,97.594,467.2z" />
//               </g>
//             </svg>
//           </div>
//           <p className="translate-x-2">Transfer</p>
//         </button>
//       </div>
//     </div>
//   );
// };

// export default PDC;

